<div class="flex flex-col p-4">
  <div class="card">
    <div class="card-body pt-0">
      @if (errorFetchingTenant) {
        <p class="text-error">
          {{ errorFetchingTenant }}
        </p>
      } @else {
        @if (loadingTenant) {
          <div class="skeleton h-[600px] w-full"></div>
        } @else if (tenant) {
          <app-tenant-info
            [tenant]="tenant"
            [franchise]="franchise"
            [loadingRegistrationDb]="loadingRegistrationDb"
            [pafUUID]="registrationDbRecords?.paf_uuid?.guid"
          ></app-tenant-info>
        }
      }
    </div>
  </div>

  <div class="px-8">
    <hr class="my-4 border-base-content/50" />
  </div>

  <!-- TABS -->
  <div class="mb-2 mt-4 px-8">
    <div role="tablist" class="tabs-boxed tabs">
      <a
        role="tab"
        class="tab"
        [ngClass]="{ 'tab-active': tab === 'desktop' }"
        (click)="switchTab('desktop')"
        >Desktop Licenses</a
      >
      <a
        role="tab"
        class="tab"
        [ngClass]="{ 'tab-active': tab === 'des-credits' }"
        (click)="switchTab('des-credits')"
        >DES Credits</a
      >
      <a
        role="tab"
        class="tab"
        [ngClass]="{ 'tab-active': tab === 'api' }"
        (click)="switchTab('api')"
        >API Subscriptions</a
      >
      <a
        role="tab"
        class="tab"
        [ngClass]="{ 'tab-active': tab === 'users' }"
        (click)="switchTab('users')"
        >User Management</a
      >
      <a
        role="tab"
        class="tab"
        [ngClass]="{ 'tab-active': tab === 'payment-methods' }"
        (click)="switchTab('payment-methods')"
        >Payment Methods</a
      >
    </div>
  </div>

  <!-- LICENSES -->
  @if (tab === 'desktop') {
    <div class="card">
      <div class="card-body py-4">
        <div class="flex justify-between" [class.mb-4]="!licensesCollapsed">
          <p class="card-title">
            <span
              class="inline-block h-6 w-6 cursor-pointer"
              (click)="licensesCollapsed = !licensesCollapsed"
            >
              @if (licensesCollapsed) {
                <app-chevron-right-icon></app-chevron-right-icon>
              } @else {
                <app-chevron-down-icon></app-chevron-down-icon>
              }
            </span>
            Licenses
          </p>

          <div [class.hidden]="licensesCollapsed">
            @if (!errorFetchingLicenses) {
              @if (loadingLicenses) {
                <div class="skeleton inline-flex h-8 w-28 rounded-md"></div>
                <div
                  class="skeleton ml-4 inline-flex h-8 w-28 rounded-md"
                ></div>
                <div
                  class="skeleton ml-4 inline-flex h-8 w-28 rounded-md"
                ></div>
              } @else {
                <button
                  class="btn btn-primary btn-sm"
                  (click)="showAddLicenseTable()"
                >
                  + Add License
                </button>
                <button
                  class="btn btn-primary btn-sm ml-4"
                  (click)="showInitialUniqueIDDialog()"
                >
                  Assign Initial Unique IDs
                </button>

                <button
                  class="btn btn-primary btn-sm ml-4"
                  (click)="showEmailActivationKeysDialog()"
                >
                  Email Activation Keys
                </button>
              }
            }
          </div>
        </div>

        <div [class.hidden]="licensesCollapsed">
          @if (errorFetchingLicenses) {
            <p class="text-error">
              {{ errorFetchingLicenses }}
            </p>
          } @else {
            @if (loadingLicenses) {
              <div class="skeleton mb-4 h-4 w-28 rounded-md"></div>
              <div class="skeleton h-28 rounded-md"></div>
            } @else {
              @if (desktopLicenses?.active) {
                <div class="mb-2 text-lg">Active</div>
                @if (desktopLicenses?.active?.length === 0) {
                  <div>
                    <p>No active licenses</p>
                  </div>
                } @else {
                  <app-licenses-table
                    [licenses]="desktopLicenses?.active"
                    [current-sort]="currentLicenseSort"
                    (sort-change)="sortLicenses($event)"
                    (license-transferred)="handleLicenseTransferred($event)"
                  ></app-licenses-table>
                }
              }

              @if (
                desktopLicenses?.pending &&
                (desktopLicenses?.pending)!.length > 0
              ) {
                <div class="mb-2 mt-8 text-lg">Pending</div>
                <app-licenses-table
                  [licenses]="desktopLicenses!.pending"
                  [current-sort]="currentLicenseSort"
                  (sort-change)="sortLicenses($event)"
                ></app-licenses-table>
              }

              @if (
                desktopLicenses?.expired &&
                (desktopLicenses?.expired)!.length > 0
              ) {
                <div class="mb-2 mt-8 text-lg">Expired</div>
                <app-licenses-table
                  [licenses]="desktopLicenses!.expired"
                  [current-sort]="currentLicenseSort"
                  (sort-change)="sortLicenses($event)"
                ></app-licenses-table>
              }

              @if (
                desktopLicenses?.disabled &&
                (desktopLicenses?.disabled)!.length > 0
              ) {
                <div class="mb-2 mt-8 text-lg">Disabled</div>
                <app-licenses-table
                  [licenses]="desktopLicenses!.disabled"
                  [current-sort]="currentLicenseSort"
                  (sort-change)="sortLicenses($event)"
                ></app-licenses-table>
              }
            }
          }
        </div>
      </div>
    </div>

    <div class="px-8">
      <hr class="my-4 border-base-content/50" />
    </div>

    <app-tenant-activation-keys
      [tenantId]="tenant?.id"
    ></app-tenant-activation-keys>

    <div class="px-8">
      <hr class="my-4 border-base-content/50" />
    </div>

    <!-- INVOICES -->
    <div class="card">
      <div class="card-body py-4">
        <div class="flex justify-between">
          <div class="card-title">
            <span
              class="inline-block h-6 w-6 cursor-pointer"
              (click)="invoicesCollapsed = !invoicesCollapsed"
            >
              @if (invoicesCollapsed) {
                <app-chevron-right-icon></app-chevron-right-icon>
              } @else {
                <app-chevron-down-icon></app-chevron-down-icon>
              }
            </span>
            Invoices
          </div>

          <div [class.hidden]="invoicesCollapsed">
            @if (!errorFetchingLicenses) {
              @if (loadingLicenses) {
                <div class="skeleton h-8 w-28 rounded-md"></div>
              } @else {
                <div
                  [ngClass]="
                    hasNoLicenses() || hasPendingInvoice()
                      ? 'tooltip tooltip-left'
                      : ''
                  "
                  [attr.data-tip]="
                    hasNoLicenses()
                      ? 'Customer has no licenses. Add a license before you can create an invoice.'
                      : 'Customer already has a pending invoice. Cannot create a new invoice.'
                  "
                >
                  <button
                    class="btn btn-primary btn-sm"
                    (click)="showCreateInvoiceModal()"
                    [disabled]="hasPendingInvoice() || hasNoLicenses()"
                  >
                    + Create Invoice
                  </button>
                </div>
              }
            }
          </div>
        </div>

        <div [class.hidden]="invoicesCollapsed">
          @if (errorFetchingInvoices) {
            <div class="pt-8 text-center">
              <p class="text-error">Error fetching invoices</p>
            </div>
          } @else if (loadingInvoices) {
            <div class="skeleton h-28"></div>
          } @else if (desktopInvoices) {
            @if (
              desktopInvoices.pending && desktopInvoices.pending!.length > 0
            ) {
              <p class="pb-2 pt-4 text-lg">Pending</p>
              <app-invoices-table
                [invoices]="desktopInvoices.pending"
                [current-sort]="currentInvoiceSort"
                (sort-changed)="sortInvoices($event)"
                (delete-invoice)="promptDeleteInvoice($event)"
              ></app-invoices-table>
            }

            @if (
              desktopInvoices.complete && desktopInvoices.complete.length > 0
            ) {
              <p class="pb-2 pt-4 text-lg">Completed</p>
              <app-invoices-table
                [invoices]="desktopInvoices!.complete"
                [current-sort]="currentInvoiceSort"
                (sort-changed)="sortInvoices($event)"
                (delete-invoice)="promptDeleteInvoice($event)"
                (change-status)="promptChangeStatus($event)"
              ></app-invoices-table>
            }

            @if (
              desktopInvoices.expired && desktopInvoices.expired.length > 0
            ) {
              <p class="pb-2 pt-4 text-lg">Expired</p>
              <app-invoices-table
                [invoices]="desktopInvoices.expired"
                [current-sort]="currentInvoiceSort"
                (sort-changed)="sortInvoices($event)"
                (delete-invoice)="promptDeleteInvoice($event)"
              ></app-invoices-table>
            }
          }
        </div>
      </div>
    </div>

    <div class="px-8">
      <hr class="my-4 border-base-content/50" />
    </div>

    <app-sent-activation-key-emails
      #sentActivationKeyEmails
      [tenantId]="tenant?.id"
    ></app-sent-activation-key-emails>

    <div class="px-8">
      <hr class="my-4 border-base-content/50" />
    </div>

    @if (isPortalAdmin()) {
      <div class="card">
        <div class="card-body py-4">
          <div
            class="flex flex-wrap items-center justify-between gap-2"
            [class.mb-4]="!regCollapsed"
          >
            <p class="card-title pb-1">
              <span
                class="inline-block h-6 w-6 cursor-pointer"
                (click)="regCollapsed = !regCollapsed"
              >
                @if (regCollapsed) {
                  <app-chevron-right-icon></app-chevron-right-icon>
                } @else {
                  <app-chevron-down-icon></app-chevron-down-icon>
                }
              </span>
              Registration Database
            </p>
            <button
              type="button"
              class="btn btn-outline btn-sm"
              [class.hidden]="regCollapsed"
              [disabled]="loadingRegistrationDb"
              (click)="loadRegistrationDbRecords()"
            >
              @if (loadingRegistrationDb) {
                <span class="loading loading-spinner loading-sm"></span>
              }
              Refresh
            </button>
          </div>

          <div [class.hidden]="regCollapsed">
            <div class="mb-2 flex flex-wrap items-center justify-between gap-2">
              <p class="text-lg">Desktop Licenses</p>
            </div>

            @if (errorRegistrationDb) {
              <p class="text-error">{{ errorRegistrationDb }}</p>
            } @else if (loadingRegistrationDb && !registrationDbRecords) {
              <div class="skeleton h-32 w-full"></div>
            } @else {
              <label
                class="input input-bordered mb-4 flex w-full max-w-md items-center gap-2"
              >
                <span class="opacity-70">Filter</span>
                <input
                  type="search"
                  class="grow"
                  placeholder="Unique ID, computer name, or GUID"
                  [(ngModel)]="registrationDbFilter"
                />
              </label>

              <div class="mb-2 flex flex-wrap gap-2 text-sm">
                <span class="opacity-70">Sort:</span>
                <button
                  type="button"
                  class="btn btn-xs"
                  [ngClass]="{
                    'btn-primary': registrationDbSortField === 'lastused',
                  }"
                  (click)="registrationDbSort('lastused')"
                >
                  Last used
                  {{
                    registrationDbSortField === 'lastused'
                      ? registrationDbSortDir === 'asc'
                        ? '↑'
                        : '↓'
                      : ''
                  }}
                </button>
                <button
                  type="button"
                  class="btn btn-xs"
                  [ngClass]="{
                    'btn-primary': registrationDbSortField === 'uniqueid',
                  }"
                  (click)="registrationDbSort('uniqueid')"
                >
                  Unique ID
                  {{
                    registrationDbSortField === 'uniqueid'
                      ? registrationDbSortDir === 'asc'
                        ? '↑'
                        : '↓'
                      : ''
                  }}
                </button>
                <button
                  type="button"
                  class="btn btn-xs"
                  [ngClass]="{
                    'btn-primary': registrationDbSortField === 'computername',
                  }"
                  (click)="registrationDbSort('computername')"
                >
                  Computer
                  {{
                    registrationDbSortField === 'computername'
                      ? registrationDbSortDir === 'asc'
                        ? '↑'
                        : '↓'
                      : ''
                  }}
                </button>
                <button
                  type="button"
                  class="btn btn-xs"
                  [ngClass]="{
                    'btn-primary': registrationDbSortField === 'active',
                  }"
                  (click)="registrationDbSort('active')"
                >
                  Active
                  {{
                    registrationDbSortField === 'active'
                      ? registrationDbSortDir === 'asc'
                        ? '↑'
                        : '↓'
                      : ''
                  }}
                </button>
              </div>

              <div
                class="overflow-x-auto rounded-lg border border-base-content/20"
              >
                <table class="table table-zebra table-sm">
                  <thead>
                    <tr>
                      <th>Unique ID</th>
                      <th>Computer</th>
                      <th>GUID</th>
                      <th>Last used</th>
                      <th>Active</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      rec of filteredRegistrationDbRows;
                      track rec.registration_id
                    ) {
                      <tr>
                        <td class="font-mono text-xs">
                          {{ rec.uniqueid || '—' }}
                        </td>
                        <td>{{ rec.computername || '—' }}</td>
                        <td class="font-mono text-xs">{{ rec.guid || '—' }}</td>
                        <td>{{ rec.lastused || '—' }}</td>
                        <td>
                          <span
                            class="badge"
                            [ngClass]="{
                              'badge-success':
                                rec.active === 1 || rec.active === 3,
                              'badge-warning':
                                rec.active === 2 || rec.active === 0,
                            }"
                            >{{ rec.active }}</span
                          >
                        </td>
                        <td class="text-right">
                          @if (isRegistrationActive(rec)) {
                            <button
                              type="button"
                              class="btn btn-outline btn-xs"
                              [disabled]="
                                registrationDbBusyId === rec.registration_id
                              "
                              (click)="promptDeactivateRegistrationRecord(rec)"
                            >
                              Deactivate
                            </button>
                          } @else {
                            <button
                              type="button"
                              class="btn btn-outline btn-xs"
                              [disabled]="
                                registrationDbBusyId === rec.registration_id
                              "
                              (click)="promptActivateRegistrationRecord(rec)"
                            >
                              Activate
                            </button>
                          }
                        </td>
                      </tr>
                    } @empty {
                      <tr>
                        <td colspan="6" class="text-center opacity-70">
                          No desktop license registration rows.
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }

            <div
              class="mb-2 mt-6 flex flex-wrap items-center justify-between gap-2"
            >
              <p class="text-lg">New Desktop License Records</p>
              <div class="flex flex-wrap gap-2">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  (click)="openCreateNewLicenseDialog()"
                >
                  Create New License Record
                </button>
              </div>
            </div>

            @if (errorRegistrationDb) {
              <p class="text-error">{{ errorRegistrationDb }}</p>
            } @else if (loadingRegistrationDb && !registrationDbRecords) {
              <div class="skeleton h-32 w-full"></div>
            } @else {
              <div
                class="overflow-x-auto rounded-lg border border-base-content/20"
              >
                <table class="table table-zebra table-sm">
                  <thead>
                    <tr>
                      <th>Features</th>
                      <th>Products</th>
                      <th>Expiration</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      rec of newDesktopLicenseRows;
                      track rec.registration_id
                    ) {
                      <tr>
                        <td class="font-mono text-xs">
                          {{ rec.features || '—' }}
                        </td>
                        <td>
                          @if (rec.products.length) {
                            <ul class="list-disc pl-4">
                              @for (
                                product of rec.products;
                                track product.code
                              ) {
                                <li>
                                  {{ product.code }} - {{ product.title }}
                                </li>
                              }
                            </ul>
                          } @else {
                            —
                          }
                        </td>
                        <td>{{ rec.expiration || '—' }}</td>
                        <td class="text-right">
                          <button
                            type="button"
                            class="btn btn-outline btn-error btn-xs"
                            [disabled]="
                              registrationDbBusyId === rec.registration_id
                            "
                            (click)="promptDeleteNewLicenseRecord(rec)"
                          >
                            @if (registrationDbBusyId === rec.registration_id) {
                              <span
                                class="loading loading-spinner loading-xs"
                              ></span>
                            }
                            Delete
                          </button>
                        </td>
                      </tr>
                    } @empty {
                      <tr>
                        <td colspan="4" class="text-center opacity-70">
                          No new desktop license records.
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        </div>
      </div>
    }
  }

  <!-- DES CREDITS -->
  @if (tab === 'des-credits') {
    <app-tenant-des-credits
      [records]="desCreditRecords"
      [accountNumber]="tenant?.account_number || ''"
      [tenantId]="tenant?.id || ''"
      [loading]="loadingRegistrationDb"
      [error]="errorRegistrationDb"
      [desApiKeyLink]="registrationDbRecords?.des_api_key_link"
      (updated)="onDesCreditsUpdated($event)"
    ></app-tenant-des-credits>
  }

  <!-- API SUBSCRIPTION -->
  @if (tab === 'api') {
    <div class="card">
      <div class="card-body">
        <div class="mb-4 flex justify-between">
          <p class="card-title">API Subscription</p>

          @if (!errorFetchingApiSubscription) {
            @if (loadingApiSubscription) {
              <div class="skeleton h-8 w-28 rounded-md"></div>
            } @else {
              <button
                class="btn btn-primary btn-sm"
                (click)="showAddApiSubscriptionModal()"
                [disabled]="apiSubscription"
                [ngClass]="apiSubscription ? 'tooltip tooltip-left' : ''"
                [attr.data-tip]="
                  apiSubscription
                    ? 'Customer already has an API subscription. Cannot add a new one.'
                    : ''
                "
              >
                + Add API Subscription
              </button>
            }
          }
        </div>
        @if (errorFetchingApiSubscription) {
          <p class="text-error">
            {{ errorFetchingApiSubscription }}
          </p>
        } @else if (loadingApiSubscription) {
          <div class="skeleton h-28 rounded-md"></div>
        } @else if (apiSubscription) {
          <div class="overflow-x-auto rounded-lg border border-base-content/20">
            <table class="table table-zebra">
              <thead class="text-base font-medium">
                <tr>
                  <td>API Product</td>
                  <td>Start Date</td>
                  <td class="w-10"></td>
                </tr>
              </thead>
              <tbody>
                <tr class="align-top">
                  <td>
                    <div>{{ apiSubscription.api_product.title }}</div>
                    @if (
                      apiSubscription.api_subscription.notes &&
                      apiSubscription.api_subscription.notes.trim() !== ''
                    ) {
                      <div class="mt-1 flex min-w-0 items-start gap-2">
                        <div
                          class="min-w-0 flex-1 whitespace-pre-wrap text-sm text-base-content/70"
                          style="
                            overflow-wrap: anywhere;
                            word-break: break-word;
                          "
                        >
                          {{ apiSubscription.api_subscription.notes }}
                        </div>
                      </div>
                    }
                  </td>
                  <td>
                    {{
                      apiSubscription.api_subscription.start_date
                        | date: 'MM/dd/yyyy' : 'UTC'
                    }}
                  </td>
                  <td class="w-10">
                    <a
                      [routerLink]="
                        '/admin/edit-subscription/' +
                        apiSubscription.api_subscription.id
                      "
                    >
                      <div class="h-6 w-6 hover:text-base-content/80">
                        <app-edit-icon></app-edit-icon>
                      </div>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-4">
            <button
              class="btn btn-primary btn-sm"
              (click)="navigateToApiJobLogs()"
            >
              Go to API Job Logs
            </button>
          </div>
        } @else {
          <p>No API subscription</p>
        }
      </div>
    </div>

    <div class="px-8">
      <hr class="my-4 border-base-content/50" />
    </div>

    <app-tenant-api-key
      [tenantId]="tenant?.id"
      [desApiKeyLink]="registrationDbRecords?.des_api_key_link"
      [desApiKeyLinkLoading]="loadingRegistrationDb"
      [desApiKeyLinkLoadError]="errorRegistrationDb"
    ></app-tenant-api-key>

    <div class="px-8">
      <hr class="my-4 border-base-content/50" />
    </div>

    <!-- API INVOICES -->
    <div class="card">
      <div class="card-body">
        <div class="mb-4 flex justify-between">
          <p class="card-title">API Invoices</p>

          @if (!errorFetchingApiInvoices) {
            @if (loadingApiInvoices) {
              <div class="skeleton h-8 w-28 rounded-md"></div>
            }
          }
        </div>
        @if (errorFetchingApiInvoices) {
          <div class="pt-8 text-center">
            <p class="text-error">Error fetching API invoices</p>
          </div>
        } @else {
          <p class="pt-4 text-lg">Pending</p>
          @if (loadingApiInvoices) {
            <div class="skeleton h-28"></div>
          } @else if (apiInvoices) {
            @if (apiInvoices.pending.length > 0) {
              <app-api-invoices-table
                [invoices]="apiInvoices!.pending"
                [current-sort]="currentApiInvoiceSort"
                (sort-changed)="sortApiInvoices($event)"
                (delete-invoice)="promptDeleteApiInvoice($event)"
                (change-status)="promptChangeApiInvoiceStatus($event)"
              ></app-api-invoices-table>
            } @else {
              <div>
                <p>No pending API invoices</p>
              </div>
            }
          }

          <p class="pt-4 text-lg">Completed</p>
          @if (loadingApiInvoices) {
            <div class="skeleton h-28"></div>
          } @else if (apiInvoices) {
            @if (apiInvoices.complete.length > 0) {
              <app-api-invoices-table
                [invoices]="apiInvoices!.complete"
                [current-sort]="currentApiInvoiceSort"
                (sort-changed)="sortApiInvoices($event)"
                (delete-invoice)="promptDeleteApiInvoice($event)"
                (change-status)="promptChangeApiInvoiceStatus($event)"
              ></app-api-invoices-table>
            } @else {
              <div>
                <p>No completed API invoices</p>
              </div>
            }
          }

          <p class="pt-4 text-lg">Expired</p>
          @if (loadingApiInvoices) {
            <div class="skeleton h-28"></div>
          } @else if (apiInvoices) {
            @if (apiInvoices.expired.length > 0) {
              <app-api-invoices-table
                [invoices]="apiInvoices!.expired"
                [current-sort]="currentApiInvoiceSort"
                (sort-changed)="sortApiInvoices($event)"
                (delete-invoice)="promptDeleteApiInvoice($event)"
                (change-status)="promptChangeApiInvoiceStatus($event)"
              ></app-api-invoices-table>
            } @else {
              <div>
                <p>No expired API invoices</p>
              </div>
            }
          }
        }
      </div>
    </div>
  }

  <!-- USERS -->
  @if (tab === 'users') {
    <div class="card">
      <div class="card-body">
        <div class="card-title mb-4 justify-between">
          <p>Users</p>
          @if (!errorFetchingUsers) {
            @if (loadingUsers) {
              <div class="skeleton h-8 w-28 rounded-md"></div>
            } @else {
              <button
                class="btn btn-primary btn-sm"
                onclick="inviteUserModal.showModal()"
              >
                Invite a User
              </button>
            }
          }
        </div>

        @if (errorFetchingUsers) {
          <div class="text-center">
            <p class="text-error">Error fetching users</p>
          </div>
        } @else {
          @if (loadingUsers) {
            <div class="skeleton h-28 rounded-md"></div>
          }
          @if (!loadingUsers) {
            <app-users-table
              [users]="users"
              [currentSort]="currentUserSort"
              (sort-changed)="sortUsers($event)"
            ></app-users-table>
          }
        }
      </div>

      @if (!errorFetchingUsers) {
        <dialog
          #inviteUserModal
          id="inviteUserModal"
          class="modal modal-bottom sm:modal-middle"
        >
          <div class="modal-box">
            <h3 class="text-lg font-bold">Invite a User</h3>
            @if (errorFetchingRoles) {
              <div>
                <p class="py-4 text-error">Error fetching roles</p>
                <div class="modal-action">
                  <form method="dialog">
                    <button class="btn btn-neutral">Cancel</button>
                  </form>
                </div>
              </div>
            } @else if (roles) {
              <div>
                <div class="py-4">
                  <div class="mt-8">
                    @if (!sendingInvitation && !successSendingInvitation) {
                      <div class="columns-2">
                        <label class="form-control w-full max-w-xs">
                          <div class="label">
                            <span class="label-text">Email</span>
                          </div>
                          <input
                            type="text"
                            class="input input-bordered w-full max-w-xs"
                            [(ngModel)]="invitationEmail"
                            placeholder="Email"
                          />
                        </label>
                        <label class="form-control w-full max-w-xs">
                          <div class="label">
                            <span class="label-text">Role</span>
                          </div>
                          <select
                            class="select select-bordered"
                            [(ngModel)]="selectedRoleId"
                          >
                            <option disabled selected>Select Role</option>
                            @for (role of roles; track role) {
                              <option [value]="role.id">
                                {{ role.name }}
                              </option>
                            }
                          </select>
                        </label>
                      </div>
                    }
                    @if (sendingInvitation) {
                      <div class="mt-4 flex flex-col items-center text-center">
                        <span
                          class="loading loading-spinner loading-lg text-primary"
                        ></span>
                        <p class="mt-4">Sending Invitation...</p>
                      </div>
                    }
                    @if (successSendingInvitation) {
                      <div class="mt-4 flex flex-col items-center text-center">
                        <app-check-circle-icon
                          class="h-12 w-12 text-success"
                        ></app-check-circle-icon>
                        <p class="mt-4">Invitation Sent Successfully</p>
                      </div>
                    }
                  </div>
                </div>
                <div class="modal-action">
                  @if (successSendingInvitation) {
                    <form method="dialog">
                      <button class="btn btn-neutral">Close</button>
                      <button
                        class="btn btn-primary ml-4"
                        (click)="successSendingInvitation = false"
                      >
                        Invite Another User
                      </button>
                    </form>
                  }
                  @if (!successSendingInvitation) {
                    <form method="dialog">
                      <!-- if there is a button in form, it will close the modal -->
                      <button class="btn btn-neutral">Cancel</button>
                      <button
                        class="btn btn-primary ml-4"
                        (click)="sendInvitation()"
                        [disabled]="sendingInvitation"
                      >
                        Send Invitation
                      </button>
                    </form>
                  }
                </div>
              </div>
            }
          </div>
        </dialog>
      }
    </div>

    <div class="px-8">
      <hr class="my-4 border-base-content/50" />
    </div>

    <!-- USER INVITATIONS -->
    <div class="card">
      <div class="card-body">
        <div class="card-title mb-2">Invitations</div>

        @if (errorRevokingInvitation) {
          <div class="py-4 text-center text-error">
            <p>{{ errorRevokingInvitation }}</p>
          </div>
        }

        @if (errorFetchingInvitations) {
          <div class="pt-8 text-center">
            <p class="text-error">Error fetching invitations</p>
          </div>
        } @else {
          <p class="pt-4 text-lg">Pending</p>
          @if (loadingInvitations) {
            <div class="skeleton h-28"></div>
          } @else if (invitations) {
            @if (invitations.pending.length === 0) {
              <div>
                <p>No pending invitations</p>
              </div>
            }
            @if (invitations.pending.length > 0) {
              <div
                class="overflow-x-auto rounded-lg border border-base-content/20"
              >
                <table class="table table-zebra static">
                  <thead class="text-base font-medium">
                    <tr>
                      <td>Email</td>
                      <td>Link</td>
                      <td>Used</td>
                      <td>Expiration</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      pendingInvitation of invitations.pending;
                      track pendingInvitation;
                      let i = $index
                    ) {
                      <tr>
                        <td>{{ pendingInvitation.email }}</td>
                        <td>
                          <button
                            class="btn btn-primary btn-sm"
                            (click)="copyInvitationLink(pendingInvitation)"
                          >
                            Copy Link
                          </button>
                        </td>
                        <td>{{ pendingInvitation.used }}</td>
                        <td>
                          {{
                            pendingInvitation.expiration
                              | date: 'MM/dd/yyyy' : 'UTC'
                          }}
                        </td>
                        <td
                          class="link"
                          (click)="revokeInvitation(pendingInvitation)"
                        >
                          Revoke
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          }

          <p class="pt-4 text-lg">Accepted</p>
          @if (loadingInvitations) {
            <div class="skeleton h-28"></div>
          } @else if (invitations) {
            @if (invitations.accepted.length === 0) {
              <div>
                <p>No accepted invitations</p>
              </div>
            }
            @if (invitations.accepted.length > 0) {
              <div
                class="overflow-x-auto rounded-lg border border-base-content/20"
              >
                <table class="table table-zebra static">
                  <thead class="text-base font-medium">
                    <tr>
                      <td>Email</td>
                      <td>Used</td>
                      <td>User Created</td>
                      <td>Expiration</td>
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      invitation of invitations.accepted;
                      track invitation;
                      let i = $index
                    ) {
                      <tr>
                        <td>{{ invitation.email }}</td>
                        <td>{{ invitation.used }}</td>
                        <td>{{ invitation.user_id_created }}</td>
                        <td>
                          {{
                            invitation.expiration | date: 'MM/dd/yyyy' : 'UTC'
                          }}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          }

          <p class="pt-4 text-lg">Expired</p>
          @if (loadingInvitations) {
            <div class="skeleton h-28"></div>
          } @else if (invitations) {
            @if (invitations.expired.length === 0) {
              <div>
                <p>No expired invitations</p>
              </div>
            }
            @if (invitations.expired.length > 0) {
              <div
                class="overflow-x-auto rounded-lg border border-base-content/20"
              >
                <table class="table table-zebra static">
                  <thead class="text-base font-medium">
                    <tr>
                      <td>Email</td>
                      <td>Used</td>
                      <td>Expiration</td>
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      invitation of invitations.expired;
                      track invitation;
                      let i = $index
                    ) {
                      <tr>
                        <td>{{ invitation.email }}</td>
                        <td>{{ invitation.used }}</td>
                        <td>
                          {{
                            invitation.expiration | date: 'MM/dd/yyyy' : 'UTC'
                          }}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          }

          <p class="pt-4 text-lg">Revoked</p>
          @if (loadingInvitations) {
            <div class="skeleton h-28"></div>
          } @else if (invitations) {
            @if (invitations.revoked.length === 0) {
              <div>
                <p>No revoked invitations</p>
              </div>
            }
            @if (invitations.revoked.length > 0) {
              <div
                class="overflow-x-auto rounded-lg border border-base-content/20"
              >
                <table class="table table-zebra static">
                  <thead class="text-base font-medium">
                    <tr>
                      <td>Email</td>
                      <td>Used</td>
                      <td>Revoked</td>
                      <td>Expiration</td>
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      invitation of invitations.revoked;
                      track invitation;
                      let i = $index
                    ) {
                      <tr>
                        <td>{{ invitation.email }}</td>
                        <td>{{ invitation.used }}</td>
                        <td>{{ invitation.revoked }}</td>
                        <td>
                          {{
                            invitation.expiration | date: 'MM/dd/yyyy' : 'UTC'
                          }}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          }
        }
      </div>
    </div>
  }

  <!-- PAYMENT METHODS -->
  @if (tab === 'payment-methods') {
    <app-add-payment-method-modal
      #addPaymentMethodModal
      (methodCreated)="handlePaymentMethodCreation($event)"
    ></app-add-payment-method-modal>

    <app-remove-payment-method-modal
      #removePaymentMethodModal
      [methodToRemove]="methodToRemove"
      (deleted)="savedMethodDeleted($event)"
    ></app-remove-payment-method-modal>

    <div class="card">
      <div class="card-body">
        <div class="mb-4 flex justify-between">
          <p class="card-title">Payment Methods</p>

          @if (!errorFetchingPaymentMethods) {
            @if (loadingPaymentMethods) {
              <div class="skeleton h-8 w-28 rounded-md"></div>
            } @else {
              <button
                class="btn btn-primary btn-sm"
                (click)="showAddPaymentMethodModal()"
              >
                + Add Payment Method
              </button>
            }
          }
        </div>

        @if (errorFetchingPaymentMethods) {
          <p class="text-error">
            {{ errorFetchingPaymentMethods }}
          </p>
        } @else {
          @if (loadingPaymentMethods) {
            <div class="skeleton h-28 rounded-md"></div>
          } @else if (savedPaymentMethods) {
            @if (savedPaymentMethods.length === 0) {
              <div>
                <p>No saved payment methods</p>
              </div>
            } @else {
              <div class="flex flex-wrap">
                @for (
                  paymentMethod of savedPaymentMethods;
                  track paymentMethod
                ) {
                  <div class="p-2">
                    <app-saved-payment-card
                      [paymentMethod]="paymentMethod"
                      [canManagePaymentMethods]="true"
                      [settingDefaultMethod]="settingDefaultMethod"
                      (setDefault)="setDefaultPaymentMethod($event)"
                      (setApiDefault)="setApiDefaultPaymentMethod($event)"
                      (deleteMethod)="confirmDeleteSavedMethod($event)"
                    ></app-saved-payment-card>
                  </div>
                }
              </div>
            }
          }
        }
      </div>
    </div>
  }

  <dialog class="modal" #addLicenseDialog>
    <div class="modal-box h-2/3 max-w-3xl">
      <app-add-license
        [desktopLicenses]="desktopLicenses"
        [tenant]="tenant"
        (licensesAdded)="handleLicensesAdded($event)"
      ></app-add-license>
    </div>
  </dialog>

  <dialog class="modal" #assignInitialUniqueIDDialog>
    <div class="modal-box max-h-[90vh] max-w-5xl overflow-y-auto">
      <form method="dialog">
        <button class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2">
          ✕
        </button>
      </form>

      <h3 class="text-lg font-bold">Assign Initial Unique IDs</h3>
      <p class="mt-2">
        Copy a Unique ID from active machines below, then paste into each
        license row.
      </p>

      <div class="my-4 space-y-6">
        <div>
          <h4 class="mb-2 font-medium">Active Machines</h4>
          @if (loadingMachines) {
            <div class="skeleton h-24 w-full"></div>
          } @else if (errorFetchingMachines) {
            <p class="text-error">{{ errorFetchingMachines }}</p>
          } @else if (distinctActiveMachines.length === 0) {
            <p class="text-sm opacity-70">No active machines.</p>
          } @else {
            <div
              class="overflow-x-auto rounded-lg border border-base-content/20"
            >
              <table class="table table-zebra table-sm">
                <thead class="text-sm">
                  <tr>
                    <th class="w-[1%]"></th>
                    <th class="font-medium">Unique ID</th>
                    <th class="font-medium">Computer</th>
                    <th class="font-medium">Last used</th>
                  </tr>
                </thead>
                <tbody>
                  @for (
                    machine of distinctActiveMachines;
                    track machine.registration_id
                  ) {
                    <tr>
                      <td class="w-[1%]">
                        <span
                          class="inline-flex"
                          [ngClass]="
                            copyFeedbackRegistrationId ===
                            machine.registration_id
                              ? 'tooltip tooltip-top tooltip-open'
                              : ''
                          "
                          [attr.data-tip]="
                            copyFeedbackRegistrationId ===
                            machine.registration_id
                              ? 'Copied!'
                              : null
                          "
                        >
                          <button
                            type="button"
                            class="btn btn-outline btn-xs shrink-0 flex-nowrap gap-1"
                            (click)="
                              copyMachineUniqueId(
                                machine.uniqueid,
                                machine.registration_id
                              )
                            "
                          >
                            <app-file-copy-icon
                              class="h-4 w-4"
                            ></app-file-copy-icon>
                            Copy
                          </button>
                        </span>
                      </td>
                      <td class="max-w-md">
                        <div
                          class="flex min-w-0 items-center justify-between gap-2"
                        >
                          <span class="truncate font-mono text-xs">{{
                            machine.uniqueid
                          }}</span>
                        </div>
                      </td>
                      <td>{{ machine.computername ?? '—' }}</td>
                      <td>{{ machine.lastused ?? '—' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>

        <div>
          <h4 class="mb-2 font-medium">Licenses</h4>
          <div class="overflow-x-auto rounded-lg border border-base-content/20">
            <table class="table table-zebra table-sm">
              <thead class="text-sm">
                <tr>
                  <th class="font-medium">Product</th>
                  <th class="font-medium">Type</th>
                  <th class="min-w-[14rem] font-medium">Unique ID</th>
                </tr>
              </thead>
              <tbody>
                @for (license of licensesWithoutUniqueIDs; track license.id) {
                  <tr>
                    <td>{{ license.product.title }}</td>
                    <td>{{ getLicenseType(license) }}</td>
                    <td>
                      <div class="flex flex-wrap items-center gap-2">
                        <input
                          type="text"
                          class="input input-sm input-bordered min-w-[12rem] flex-1 font-mono text-xs"
                          placeholder="Paste or type Unique ID"
                          [ngModel]="initialUniqueIDs[license.id]"
                          (ngModelChange)="
                            handleInitialUniqueIDChange($event, license)
                          "
                        />
                        <button
                          type="button"
                          class="btn btn-outline btn-sm shrink-0 gap-1"
                          (click)="pasteUniqueIdIntoLicense(license)"
                        >
                          <app-clipboard-icon
                            class="h-4 w-4 text-current"
                          ></app-clipboard-icon>
                          Paste
                        </button>
                      </div>
                    </td>
                  </tr>
                } @empty {
                  <tr>
                    <td colspan="3" class="text-center italic opacity-70">
                      No licenses without Unique IDs
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="mt-4 flex shrink-0 justify-end gap-2">
        <button
          class="btn btn-primary"
          [disabled]="applyingInitialUniqueIds"
          (click)="applyInitialUniqueIDs()"
        >
          @if (applyingInitialUniqueIds) {
            <span class="loading loading-spinner loading-sm"></span>
            Applying…
          } @else {
            Apply
          }
        </button>
        <button
          class="btn btn-neutral"
          (click)="closeAssignInitialUniqueIDDialog()"
        >
          Cancel
        </button>
      </div>
    </div>
  </dialog>

  <app-email-activation-keys
    #emailActivationKeys
    [tenant]="tenant"
    [licenses]="desktopLicenses?.active"
    (emailed)="onActivationKeysEmailed()"
  ></app-email-activation-keys>

  <dialog class="modal" #addApiSubscriptionDialog>
    <div class="modal-box max-w-3xl">
      <app-add-api-subscription
        [tenant]="tenant"
        (apiSubscriptionAdded)="handleApiSubscriptionAdded($event)"
      ></app-add-api-subscription>
    </div>
  </dialog>

  <dialog class="modal" #createInvoiceDialog>
    <div class="modal-box max-w-[80%]">
      @if (showCreateInvoice) {
        <app-create-invoice
          [desktopLicenses]="desktopLicenses"
          [desktopInvoices]="desktopInvoices"
          (invoiceCreated)="handleInvoiceCreated($event)"
          (closeDialog)="closeCreateInvoiceDialog()"
        ></app-create-invoice>
      } @else if (errorFetchingLicenses || errorFetchingInvoices) {
        <div class="text-center">
          <p class="text-error">
            {{ errorFetchingLicenses || errorFetchingInvoices }}
          </p>
        </div>
      } @else {
        <div class="text-center">
          <p class="text-error">Unkown error loading licenses or invoices</p>
        </div>
      }
    </div>
  </dialog>

  <dialog class="modal" #deleteInvoiceDialog>
    <div class="modal-box max-w-3xl p-8">
      @if (!invoiceToDelete) {
        <p class="text-center text-error">No invoice to delete</p>
      } @else {
        <h3 class="text-lg font-bold">Confirm Invoice Deletion</h3>

        <div class="my-4">
          <div>
            <p class="mb-2">
              Invoice #:
              {{ invoiceToDelete.desktop_invoice.number }}
            </p>
            <p class="mb-2">
              Invoice created on:
              {{
                invoiceToDelete.desktop_invoice.created_at | date: 'MM/dd/yyyy'
              }}
            </p>
            <p class="mb-2">
              Total Amount:
              {{
                invoiceToDelete.desktop_invoice.total_amount | currency: 'USD'
              }}
            </p>
            <p class="mb-4 mt-2">
              Due by:
              {{ invoiceToDelete.due_by | date: 'MM/dd/yyyy' : 'UTC' }}
            </p>
          </div>
        </div>

        <div class="overflow-x-auto">
          <table class="table table-zebra">
            <thead class="text-sm">
              <tr>
                <th class="font-medium">Product</th>
                <th class="font-medium">Type</th>
                <th class="font-medium">New Expiration</th>
                <th class="text-right font-medium">Price</th>
              </tr>
            </thead>
            <tbody>
              @for (el of invoiceToDelete.license_details; track el) {
                <tr>
                  <td>{{ el.license_with_product.product.title }}</td>
                  <td>
                    {{ el.license_with_product.site_license ? 'Site' : 'Main' }}
                  </td>
                  <td>
                    {{ el.new_expiration_date | date: 'MM/dd/yyyy' : 'UTC' }}
                  </td>
                  <td class="text-right">
                    {{ el.base_amount | currency: 'USD' }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <p class="mt-8 text-sm text-error">
          This deletion is permanent. Are you sure you want to delete this
          invoice?
        </p>

        <div class="mt-4 flex justify-end">
          <button
            class="btn btn-primary mr-4"
            (click)="deleteInvoice()"
            [disabled]="deletingInvoice"
          >
            Delete
          </button>
          <button class="btn btn-neutral" (click)="closeDeleteInvoiceDialog()">
            Cancel
          </button>
        </div>
      }
    </div>
  </dialog>

  <dialog class="modal" #changeStatusDialog>
    <div class="modal-box max-w-3xl p-8">
      @if (!invoiceToChangeStatus) {
        <p class="text-center text-error">No invoice selected</p>
      } @else {
        <h3 class="text-lg font-bold">Change Invoice Status</h3>

        <div class="my-4">
          <div>
            <p class="mb-2">
              Invoice #:
              {{ invoiceToChangeStatus.desktop_invoice.number }}
            </p>
            <p class="mb-2">
              Current Status:
              {{ invoiceToChangeStatus.desktop_invoice.status || 'None' }}
            </p>
            <p class="mb-2">
              Invoice created on:
              {{
                invoiceToChangeStatus.desktop_invoice.created_at
                  | date: 'MM/dd/yyyy'
              }}
            </p>
            <p class="mb-2">
              Total Amount:
              {{
                invoiceToChangeStatus.desktop_invoice.total_amount
                  | currency: 'USD'
              }}
            </p>
          </div>
        </div>

        <div class="my-4">
          <label class="label">
            <span class="label-text">New Status</span>
          </label>
          <select
            class="select select-bordered w-full"
            [(ngModel)]="newInvoiceStatus"
          >
            <option [ngValue]="null">Completed</option>
            <option [ngValue]="'refunded'">Refunded</option>
            <option [ngValue]="'voided'">Voided</option>
          </select>
        </div>

        @if (errorChangingStatus) {
          <div class="mb-4 text-error">
            {{ errorChangingStatus }}
          </div>
        }

        <div class="flex justify-end space-x-4">
          <button
            class="btn btn-primary"
            (click)="updateInvoiceStatus()"
            [disabled]="changingStatus"
          >
            @if (changingStatus) {
              <span class="loading loading-spinner loading-sm"></span>
            } @else {
              Update Status
            }
          </button>
          <button
            class="btn btn-neutral"
            (click)="closeChangeStatusDialog()"
            [disabled]="changingStatus"
          >
            Cancel
          </button>
        </div>
      }
    </div>
  </dialog>

  <dialog class="modal" #changeApiInvoiceStatusDialog>
    <div class="modal-box max-w-3xl p-8">
      @if (!apiInvoiceToChangeStatus) {
        <p class="text-center text-error">No API invoice selected</p>
      } @else {
        <h3 class="text-lg font-bold">Change API Invoice Status</h3>

        <div class="my-4">
          <div>
            <p class="mb-2">
              Invoice #:
              {{ apiInvoiceToChangeStatus.number }}
            </p>
            <p class="mb-2">
              Current Status:
              {{ apiInvoiceToChangeStatus.status || 'None' }}
            </p>
            <p class="mb-2">
              Invoice created on:
              {{
                apiInvoiceToChangeStatus.created_at | date: 'MM/dd/yyyy' : 'UTC'
              }}
            </p>
            <p class="mb-2">
              Total Amount:
              {{ apiInvoiceToChangeStatus.total_amount | currency: 'USD' }}
            </p>
          </div>
        </div>

        <div class="my-4">
          <label class="label">
            <span class="label-text">New Status</span>
          </label>
          <select
            class="select select-bordered w-full"
            [(ngModel)]="newApiInvoiceStatus"
          >
            <option [ngValue]="null">Completed</option>
            <option [ngValue]="'refunded'">Refunded</option>
            <option [ngValue]="'voided'">Voided</option>
          </select>
        </div>

        @if (errorChangingApiInvoiceStatus) {
          <div class="mb-4 text-error">
            {{ errorChangingApiInvoiceStatus }}
          </div>
        }

        <div class="flex justify-end space-x-4">
          <button
            class="btn btn-primary"
            (click)="submitApiInvoiceStatusChange()"
            [disabled]="changingApiInvoiceStatus"
          >
            @if (changingApiInvoiceStatus) {
              <span class="loading loading-spinner loading-sm"></span>
            } @else {
              Update Status
            }
          </button>
          <button
            class="btn btn-neutral"
            (click)="closeChangeApiInvoiceStatusDialog()"
            [disabled]="changingApiInvoiceStatus"
          >
            Cancel
          </button>
        </div>
      }
    </div>
  </dialog>

  <dialog class="modal" #deleteApiInvoiceDialog>
    <div class="modal-box max-w-3xl p-8">
      @if (!apiInvoiceToDelete) {
        <p class="text-center text-error">No API invoice to delete</p>
      } @else {
        <h3 class="text-lg font-bold">Confirm API Invoice Deletion</h3>

        <div class="my-4">
          <div>
            <p class="mb-2">
              Invoice #:
              {{ apiInvoiceToDelete.number }}
            </p>
            <p class="mb-2">
              Invoice created on:
              {{ apiInvoiceToDelete.created_at | date: 'MM/dd/yyyy' : 'UTC' }}
            </p>
            <p class="mb-2">
              Total Amount:
              {{ apiInvoiceToDelete.total_amount | currency: 'USD' }}
            </p>
            <p class="mb-2">
              Transaction Month:
              {{
                getDisplayTransactionMonth(
                  apiInvoiceToDelete.transaction_yyyymm
                ) | date: 'MM/YYYY'
              }}
            </p>
            <p class="mb-2">
              Job Count:
              {{ apiInvoiceToDelete.job_count }}
            </p>
            <p class="mb-4 mt-2">
              Due by:
              {{ apiInvoiceToDelete.expiration | date: 'MM/dd/yyyy' : 'UTC' }}
            </p>
          </div>
        </div>

        <p class="mt-8 text-sm text-error">
          This deletion is permanent. Are you sure you want to delete this API
          invoice?
        </p>

        @if (errorDeletingApiInvoice) {
          <div class="mt-4 text-error">
            {{ errorDeletingApiInvoice }}
          </div>
        }

        <div class="mt-4 flex justify-end">
          <button
            class="btn btn-primary mr-4"
            (click)="deleteApiInvoice()"
            [disabled]="deletingApiInvoice"
          >
            @if (deletingApiInvoice) {
              <span class="loading loading-spinner loading-sm"></span>
            } @else {
              Delete
            }
          </button>
          <button
            class="btn btn-neutral"
            (click)="closeDeleteApiInvoiceDialog()"
          >
            Cancel
          </button>
        </div>
      }
    </div>
  </dialog>

  <dialog class="modal" #registrationRecordConfirmDialog>
    <div class="modal-box max-w-lg p-8">
      @if (!registrationRecordPendingConfirm) {
        <p class="text-center text-error">No registration record selected</p>
      } @else {
        <h3 class="text-lg font-bold">
          @if (registrationRecordPendingConfirm.action === 'deactivate') {
            Deactivate registration record?
          } @else {
            Activate registration record?
          }
        </h3>
        <div class="my-4 text-sm">
          <p class="mb-1">
            <span class="opacity-70">Unique ID:</span>
            {{ registrationRecordPendingConfirm.rec.uniqueid || '—' }}
          </p>
          <p class="mb-1">
            <span class="opacity-70">Computer:</span>
            {{ registrationRecordPendingConfirm.rec.computername || '—' }}
          </p>
          <p>
            <span class="opacity-70">GUID:</span>
            {{ registrationRecordPendingConfirm.rec.guid || '—' }}
          </p>
        </div>
        <p class="text-sm">
          @if (registrationRecordPendingConfirm.action === 'deactivate') {
            This row will be marked inactive for this tenant.
          } @else {
            This row will be marked active for this tenant.
          }
        </p>
        <div class="mt-6 flex justify-end gap-2">
          <button
            type="button"
            class="btn btn-neutral"
            (click)="closeRegistrationRecordConfirmDialog()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn"
            [ngClass]="
              registrationRecordPendingConfirm.action === 'deactivate'
                ? 'btn-error'
                : 'btn-primary'
            "
            (click)="confirmRegistrationRecordPending()"
          >
            @if (registrationRecordPendingConfirm.action === 'deactivate') {
              Deactivate
            } @else {
              Activate
            }
          </button>
        </div>
      }
    </div>
  </dialog>

  <dialog class="modal" #deleteNewLicenseConfirmDialog>
    <div class="modal-box max-w-lg p-8">
      @if (!newLicenseRecordPendingDelete) {
        <p class="text-center text-error">No license record selected</p>
      } @else {
        <h3 class="text-lg font-bold">Delete new desktop license record?</h3>
        <div class="my-4 text-sm">
          <p class="mb-1">
            <span class="opacity-70">Features:&nbsp;</span>
            <span class="font-mono text-xs">{{
              newLicenseRecordPendingDelete.features || '—'
            }}</span>
          </p>
          <p class="mb-1">
            <span class="opacity-70">Expiration:&nbsp;</span>
            {{ newLicenseRecordPendingDelete.expiration || '—' }}
          </p>
          @if (newLicenseRecordPendingDelete.products.length) {
            <p class="mb-1 opacity-70">Products:</p>
            <ul class="list-disc pl-4">
              @for (
                product of newLicenseRecordPendingDelete.products;
                track product.code
              ) {
                <li>{{ product.code }} - {{ product.title }}</li>
              }
            </ul>
          }
        </div>
        <p class="text-sm text-warning">
          This permanently deletes the Registration DB New License record. This
          cannot be undone.
        </p>
        <div class="mt-6 flex justify-end gap-2">
          <button
            type="button"
            class="btn btn-neutral"
            (click)="closeDeleteNewLicenseConfirmDialog()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-error"
            (click)="confirmDeleteNewLicenseRecord()"
          >
            Delete
          </button>
        </div>
      }
    </div>
  </dialog>

  <dialog class="modal" #createNewLicenseDialog>
    <div class="modal-box max-w-4xl p-8">
      <h3 class="text-lg font-bold">Create New Desktop License Record</h3>
      <p class="mt-1 text-sm opacity-70">
        Creates a new desktop license record for this tenant.
      </p>

      @if (loadingNewLicenseProducts) {
        <div class="skeleton mt-4 h-40 w-full"></div>
      } @else {
        <div class="mt-4">
          <p class="mb-2 font-medium">Primary product (required)</p>
          @if (!newLicenseProductCatalog?.primaries?.length) {
            <p class="text-sm opacity-70">No primary products configured.</p>
          } @else {
            <select
              class="select select-bordered w-full"
              [(ngModel)]="newLicensePrimaryCode"
            >
              <option value="" disabled>Select primary product</option>
              @for (
                product of newLicenseProductCatalog!.primaries;
                track product.code
              ) {
                <option [value]="product.code">
                  {{ product.code }} — {{ product.title }}
                </option>
              }
            </select>
          }
        </div>

        <div class="mt-4">
          <div class="flex justify-between gap-4">
            <div>
              <p class="mb-2 font-medium">Add-on products</p>
              @if (!newLicenseProductCatalog?.addons?.length) {
                <p class="text-sm opacity-70">No add-on products configured.</p>
              } @else {
                <div class="flex flex-col gap-2 overflow-y-auto">
                  @for (
                    product of newLicenseProductCatalog!.addons;
                    track product.code
                  ) {
                    <label class="flex cursor-pointer items-center gap-2">
                      <input
                        type="checkbox"
                        class="checkbox checkbox-sm"
                        [checked]="!!newLicenseAddonCodes[product.code]"
                        (change)="
                          toggleNewLicenseAddon(
                            product.code,
                            $any($event.target).checked
                          )
                        "
                      />
                      <span class="text-sm"
                        >{{ product.code }} — {{ product.title }}</span
                      >
                    </label>
                  }
                </div>
              }
            </div>
            <div>
              <p class="mb-2 font-medium">Manifest products</p>
              @if (!newLicenseProductCatalog?.manifests?.length) {
                <p class="text-sm opacity-70">
                  No manifest products configured.
                </p>
              } @else {
                <div class="flex flex-col gap-2 overflow-y-auto">
                  @for (
                    product of newLicenseProductCatalog!.manifests;
                    track product.code
                  ) {
                    <label class="flex cursor-pointer items-center gap-2">
                      <input
                        type="checkbox"
                        class="checkbox checkbox-sm"
                        [checked]="!!newLicenseManifestCodes[product.code]"
                        (change)="
                          toggleNewLicenseManifest(
                            product.code,
                            $any($event.target).checked
                          )
                        "
                      />
                      <span class="text-sm"
                        >{{ product.code }} — {{ product.title }}</span
                      >
                    </label>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <div class="form-control mt-4">
          <label class="label" for="newLicenseExpirationDate">
            <span class="label-text font-medium">Expiration date</span>
          </label>
          <input
            id="newLicenseExpirationDate"
            type="date"
            class="input input-bordered w-full"
            [(ngModel)]="newLicenseExpirationDate"
          />
        </div>
      }

      @if (newLicenseCreateError) {
        <p class="mt-3 text-sm text-error">{{ newLicenseCreateError }}</p>
      }

      <div class="mt-6 flex justify-end gap-2">
        <button
          type="button"
          class="btn btn-neutral"
          [disabled]="creatingNewLicense"
          (click)="closeCreateNewLicenseDialog()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!canSubmitNewLicense"
          (click)="submitNewLicense()"
        >
          @if (creatingNewLicense) {
            <span class="loading loading-spinner loading-sm"></span>
          }
          Create
        </button>
      </div>
    </div>
  </dialog>
</div>
